// Публічні документи платіжних систем, які показуємо гостю.
//
// ВАЖЛИВО: гостю потрібен договір ПЛАТНИКА про оплату товарів/послуг. Обидва
// посилання, що стояли тут раніше, були хибні — кожне по-своєму.
//
// LiqPay — був не той бік договору:
//   /information/terms         — Умови та Правила надання послуг: договір Банк ↔ заклад
//                                (еквайринг). До гостя не має стосунку.
//   /uk/information/user?tab=1 — публічний договір Банк ↔ платник. Саме його гість
//                                укладає натисканням «Сплатити»: за преамбулою договір
//                                укладається конклюдентними діями, а саме «натискання
//                                відповідної кнопки про ініціювання платіжної операції».
//
// Portmone — був не той продукт:
//   /r3/docs/cross-border/client_uk.pdf — «Правила користування сервісом Portmone»
//                                (ред. 2017) про переказ з картки на картку: користувач
//                                вводить номер картки Одержувача-фізособи. Гірше того,
//                                п.1.5 прямо забороняє використання сервісу для платіжних
//                                операцій, пов'язаних з підприємницькою діяльністю, —
//                                тобто саме для оплати рахунку в закладі.
//   /r3/docs/portmone-offer.pdf — «Публічний договір про надання послуг з обробки
//                                інформації» (чинний з 01.03.2025) між Портмоне та
//                                фізособою-платником. Регулює всі послуги Портмоне,
//                                а Платіж визначає як операцію «з метою оплати вартості
//                                товарів, робіт або послуг». Це наш випадок.
//
// Посилання має бути видимим до натискання кнопки оплати.
const PAYMENT_TERMS = {
  liqpay: "https://www.liqpay.ua/uk/information/user?tab=1",
  portmone: "https://www.portmone.com.ua/r3/docs/portmone-offer.pdf",
};

// Політику конфіденційності зі сторінки умов прибрано свідомо: у вимогах LiqPay
// її немає, а skyservice.pro/privacy-policy — це B2B-документ між Skyservice і
// закладом, де гість фігурує лише як чужі дані. Володільцем даних гостя за
// офертою є Заклад, і власної політики в нього поки немає.

// Ліміт однієї онлайн-операції. Правило LiqPay: «обмежити загальну суму
// Транзакції до 29 999,99 гривень з одного Платіжного засобу за один день».
// Оплата блокується, коли сума рахунку ПЕРЕВИЩУЄ цей ліміт; рівно на ньому
// платити ще можна. Тримаємо одним числом, бо раніше воно було зашите в
// чотирьох місцях з розбіжними порівняннями (`<`, `>`, `>=`), через що при
// сумі рівно 29 999 кнопка рендерилась порожньою.
export const ONLINE_PAYMENT_LIMIT = 29999;

// Для показу гостю: «29 999», а не «29999».
export const ONLINE_PAYMENT_LIMIT_LABEL =
  ONLINE_PAYMENT_LIMIT.toLocaleString("uk-UA");

// Назва платіжки приходить з двох джерел у різному регістрі:
//   getStart  → activePaymentSystem: "LiqPay" | "Portmone"
//   websocket → paymentType:         "liqpay" | "portmone"
// Через це пряме порівняння з рядком працювало лише в одному з двох місць.
export const normalizePaymentSystem = (system) =>
  typeof system === "string" ? system.trim().toLowerCase() : "";

// Посилання на договір платника для обраної платіжної системи.
// Порожній рядок, якщо система невідома або оплату не налаштовано.
export const getPaymentTermsLink = (system) =>
  PAYMENT_TERMS[normalizePaymentSystem(system)] || "";

export const isLiqPay = (system) => normalizePaymentSystem(system) === "liqpay";
